export const blogPosts = [
  {
    id: 1,
    title: 'How To Memorize Quran By Yourself | Useful Tips',
    slug: 'how-to-memorize-quran-by-yourself',
    excerpt: 'Discover useful tips and strategies to memorize the Quran by yourself at home. A comprehensive guide for self-directed Hifz journey.',
    content: 'Full article content here...',
    category: 'Quran Learning',
    author: 'Admin',
    publishDate: '2025-01-20',
    image: '/blog/memorize-quran.jpg',
    readTime: '10 min read',
    tags: ['Memorization', 'Hifz', 'Quran']
  },
  {
    id: 2,
    title: 'Top 9 Tips to Learn Quran Fast by Yourself at Home',
    slug: 'top-9-tips-to-learn-quran-fast',
    excerpt: 'Learn the most effective methods to accelerate your Quran learning journey from the comfort of your home.',
    content: 'Full article content here...',
    category: 'Quran Learning',
    author: 'Sheikh Abdul Rahman',
    publishDate: '2025-01-18',
    image: '/blog/learn-quran-fast.jpg',
    readTime: '8 min read',
    tags: ['Quran', 'Learning', 'Tips']
  },
  {
    id: 3,
    title: 'What is the Best Way to Learn Islam at Home?',
    slug: 'best-way-to-learn-islam-at-home',
    excerpt: 'A comprehensive guide on the most effective ways to learn and practice Islam from your home. Perfect for reverts and lifelong learners.',
    content: 'Full article content here...',
    category: 'Islamic Studies',
    author: 'Ustadha Fatima',
    publishDate: '2025-01-15',
    image: '/blog/learn-islam.jpg',
    readTime: '12 min read',
    tags: ['Islam', 'Learning', 'Home']
  },
  {
    id: 4,
    title: '15 Powerful Dua for Forgiveness',
    slug: '15-powerful-dua-for-forgiveness',
    excerpt: 'Discover the most powerful duas from Quran and Hadith for seeking Allah\'s forgiveness and mercy.',
    content: 'Full article content here...',
    category: 'Dua',
    author: 'Admin',
    publishDate: '2025-01-15',
    image: '/blog/dua-forgiveness.jpg',
    readTime: '8 min read',
    tags: ['Dua', 'Forgiveness', 'Islamic Prayers']
  },
  {
    id: 5,
    title: 'How to Memorize Quran in 1 Year',
    slug: 'how-to-memorize-quran-in-1-year',
    excerpt: 'A comprehensive guide with practical tips and strategies to complete Quran memorization in one year.',
    content: 'Full article content here...',
    category: 'Quran Learning',
    author: 'Sheikh Abdul Rahman',
    publishDate: '2025-01-10',
    image: '/blog/memorize-quran.jpg',
    readTime: '12 min read',
    tags: ['Hifz', 'Memorization', 'Quran']
  },
  {
    id: 6,
    title: 'Understanding the Hijab in Islam',
    slug: 'understanding-the-hijab',
    excerpt: 'An in-depth look at the significance and importance of hijab in Islamic teachings.',
    content: 'Full article content here...',
    category: 'Islamic Studies',
    author: 'Ustadha Fatima',
    publishDate: '2025-01-05',
    image: '/blog/hijab.jpg',
    readTime: '6 min read',
    tags: ['Hijab', 'Islamic Values', 'Women in Islam']
  },
  {
    id: 7,
    title: 'Complete Umrah Guide for First-Timers',
    slug: 'umrah-guide-for-first-timer',
    excerpt: 'Everything you need to know before performing your first Umrah pilgrimage.',
    content: 'Full article content here...',
    category: 'Umrah',
    author: 'Sheikh Muhammad',
    publishDate: '2025-01-01',
    image: '/blog/umrah-guide.jpg',
    readTime: '15 min read',
    tags: ['Umrah', 'Pilgrimage', 'Hajj']
  },
  {
    id: 8,
    title: 'The Best Ways to Learn Quran Online',
    slug: 'best-ways-to-learn-quran-online',
    excerpt: 'Discover effective methods and tips for learning Quran through online platforms.',
    content: 'Full article content here...',
    category: 'Online Learning',
    author: 'Admin',
    publishDate: '2024-12-28',
    image: '/blog/learn-quran-online.jpg',
    readTime: '10 min read',
    tags: ['Online Learning', 'Quran', 'Education']
  },
  {
    id: 9,
    title: 'Importance of Tajweed in Quran Recitation',
    slug: 'importance-of-tajweed',
    excerpt: 'Learn why Tajweed is essential for proper Quran recitation and how it affects meaning.',
    content: 'Full article content here...',
    category: 'Tajweed',
    author: 'Sheikh Muhammad Ali',
    publishDate: '2024-12-20',
    image: '/blog/tajweed.jpg',
    readTime: '7 min read',
    tags: ['Tajweed', 'Quran Recitation', 'Arabic']
  }
];

export const blogCategories = [
  { name: 'All', slug: 'all', count: blogPosts.length },
  { name: 'Dua', slug: 'dua', count: blogPosts.filter(p => p.category === 'Dua').length },
  { name: 'Quran Learning', slug: 'quran-learning', count: blogPosts.filter(p => p.category === 'Quran Learning').length },
  { name: 'Islamic Studies', slug: 'islamic-studies', count: blogPosts.filter(p => p.category === 'Islamic Studies').length },
  { name: 'Umrah', slug: 'umrah', count: blogPosts.filter(p => p.category === 'Umrah').length },
  { name: 'Online Learning', slug: 'online-learning', count: blogPosts.filter(p => p.category === 'Online Learning').length },
  { name: 'Tajweed', slug: 'tajweed', count: blogPosts.filter(p => p.category === 'Tajweed').length }
];

export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getPostsByCategory = (category) => {
  if (category === 'all') return blogPosts;
  return blogPosts.filter(post => post.category === category);
};

export const getRecentPosts = (limit = 3) => {
  return blogPosts.slice(0, limit);
};
